import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import * as React from 'react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useFirstRender } from '../common/effects/useFirstRender';
import { Radio } from '../radio/radio';
import styles from './radio-group.module.scss';
const RadioGroup = ({ items, disabled, onSelected, style, layout = 'column', RTL = false, focusable = true, size = 'sm', }) => {
    const [_items, setItems] = useState(Array.isArray(items)
        ? items.map(item => ({
            id: nanoid(),
            ...item,
            disabled: typeof disabled !== 'undefined' ? disabled : item.disabled,
        }))
        : []);
    const [changeTracker, setChangeTracker] = useState();
    const active = useRef();
    const handleChange = useCallback(({ id }) => {
        if (active.current !== id) {
            setItems(prev => prev.map(item => ({
                ...item,
                checked: item.id === id || false,
                isChecked: item.id === id || false,
            })));
            active.current = id;
            setChangeTracker(Date.now());
        }
    }, []);
    useEffect(() => {
        if (!isFirstRender.current) {
            const foundItem = _items.find(item => item.checked);
            const value = foundItem ? foundItem.value : undefined;
            if (value && onSelected) {
                onSelected(value);
            }
        }
    }, [changeTracker]);
    const isFirstRender = useFirstRender();
    const radioGroupClass = useMemo(() => classNames(styles.radio_group, {
        [styles.column]: layout === 'column',
        [styles.row]: layout === 'row',
    }), []);
    return (_jsx("ul", { className: radioGroupClass, role: "radiogroup", style: style, children: _items.map(({ id, disabled, label, checked }) => (_jsx(Radio, { onChange: handleChange, label: label, id: id, isChecked: checked, disabled: disabled, isControlled: true, withGroup: true, size: size, fullWidth: layout === 'column', RTL: RTL, focusable: focusable }, id))) }));
};
RadioGroup.displayName = 'RadioGroup';
export { RadioGroup };
